import { getColor } from '../../../../theme-tools';
var baseStyle = _ref => {
  var {
    theme
  } = _ref;
  return {
    container: {
      '.tqc-select': {
        '&--is-invalid .tqc-select__control': {
          border: "2px solid ".concat(getColor(theme, 'red.800')),
          '&:hover': {
            border: "2px solid ".concat(getColor(theme, 'red.800'), " !important")
          },
          _focusWithin: {
            boxShadow: "0 0 0 3px ".concat(getColor(theme, 'yellow.200'))
          }
        }
      },
      '.tqc-select__control': {
        borderRadius: '0',
        border: "1px solid ".concat(getColor(theme, 'grey.650')),
        '&:hover': {
          border: "1px solid ".concat(getColor(theme, 'grey.650'))
        },
        '&--is-focused': {
          boxShadow: "0 0 0 3px ".concat(getColor(theme, 'yellow.200'))
        },
        '&--is-disabled': {
          border: "3px solid ".concat(getColor(theme, 'grey.450')),
          bg: 'white',
          '.tqc-select__placeholder': {
            color: 'grey.850'
          },
          '.tqc-select__indicators': {
            color: '#BBBBBB'
          }
        }
      },
      '.tqc-select__indicators': {
        color: 'grey.980'
      }
    },
    menu: {
      '.tqc-select__group-heading': {
        bg: 'grey.250',
        color: 'grey.980',
        borderBottom: '1px solid #E5E5E5'
      },
      '.tqc-select__option': {
        color: 'grey.980',
        borderBottom: '1px solid #E5E5E5'
      }
    }
  };
};
export default {
  baseStyle
};